import { createEffect, createEvent, createStore, sample } from "effector";
import { http } from "../../facilities/http";

type DashboardInfo = {
  url: string;
  accessToken: string;
  refreshToken: string;
  ts: number;
};

export const dashboardMounted = createEvent<string>();
export const dashboardSessionExpired = createEvent<string>();

export const $error = createStore<Error | null>(null);
export const $dashboard = createStore<DashboardInfo | null>(null);

const dashboardLoadFx = createEffect(async (id: string) => {
  const response = await http.post<DashboardInfo>(
    `/api/dashboard/${encodeURIComponent(id)}/authorize`,
  );
  return { ...response.data, ts: new Date().getTime() };
});

export const $loading = dashboardLoadFx.pending;

sample({
  clock: [dashboardMounted, dashboardSessionExpired],
  target: dashboardLoadFx,
});

sample({
  clock: [dashboardMounted, dashboardSessionExpired],
  fn: () => null,
  target: [$error, $dashboard],
});

sample({
  clock: dashboardLoadFx.doneData,
  target: $dashboard,
});

sample({
  clock: dashboardLoadFx.failData,
  target: $error,
});
